import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="logo-icon">🍬</span>
            <span className="logo-text">Sweet & Snack World</span>
          </div>
          <p className="footer-tagline">Your Gateway to Sweet Paradise</p>
          <div className="footer-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <p className="footer-copyright">&copy; 2026 Sweet & Snack World. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
